module.exports = __webpack_public_path__ + "img/ic_add.dd484a62.svg";